import React from "react";
import { Container } from "../Servicos/style";
import { ProjectCard } from "./ProjectCard";
import { ProjectsContainer } from "./style.";
import nuKenzie from "../../assets/nukenzie.png";
import kenzieHub from "../../assets/kenziehub.png";
import adopetme from "../../assets/adopetme.png";
import htttinder from "../../assets/httinder.jpg";
import kenzieRoll from "../../assets/kenzieRoll.jpg";
import { Button } from "../Button";

export const Projects = () => {
  const projects = [
    {
      img: nuKenzie,
      title: "NuKenzie",
      description: "Gestor de finanças pessoais.",
      techs: ["React", "Styled Components"],
      github: "https://github.com/devigorgarcia/nukenzie",
      vercel: "https://react-entrega-s1-nu-kenzie-devigorgarcia.vercel.app",
    },
    {
      img: kenzieHub,
      title: "KenzieHub",
      description:
        "Um aplicativo para registrar e atualizar competencias tecnológicas",
      techs: ["React", "Styled Components", "Consumo de API"],
      github: "https://github.com/devigorgarcia/kenzieHub",
      vercel: "https://react-entrega-s2-kenzie-hub-devigorgarcia.vercel.app",
    },
    {
      img: adopetme,
      title: "adoPETme",
      description:
        "Um aplicativo que conecta ONGs de animais com protenciais adotantes. Desenvolvido em um grupo de 4 Devs.",
      techs: ["React", "Styled Components", "ContextAPI", "Hooks", "Libs"],
      github: "https://github.com/devigorgarcia/adopetme",
      vercel: "https://adopetme-drab.vercel.app/",
    },
    {
      img: htttinder,
      title: "HTTinder",
      description:
        "Um aplicativo que conecta pessoas com interesses parecidos. Desenvolvido em um grupo de 6 Devs.",
      techs: ["Typescript", "Node.JS", "Express", "TypeORM", "JWT", "Postgres"],
      github: "https://github.com/devigorgarcia/httTinder-Api",
      vercel: "https://htttinder.github.io/docs/",
    },
    {
      img: kenzieRoll,
      title: "KenzieRoll",
      description:
        "Um aplicativo que o usuario acompanha seus animes preferidos. Desenvolvido em um grupo de 6 Devs.",
      techs: ["Python", "Django", "Postgres", "Django Rest Framework"],
      github: "https://github.com/G07-lucira/projeto-final-python-M5-G07",
      vercel: "https://kenzieroll-g07.herokuapp.com/api/docs/",
    },
  ];
  return (
    <Container>
      <h2 className="title">Projetos</h2>
      <ProjectsContainer>
        {projects.map((project, index) => (
          <ProjectCard key={index} project={project} />
        ))}
      </ProjectsContainer>
      <Button>Entre Em Contato!</Button>
    </Container>
  );
};
